<template>
  <div class="sidebar-chat-with-user list">
     <!--
    <h5>Incomming Tasks</h5>
    <div v-if="sharedCommitment.$ready" style="border: 2px solid grey">
      <kanban-list
        style="margin: 0 auto;"
        :show-header="false"
        :lane="sharedCommitment"
        :goal-id="sharedGoalId"
        :loading="tasks_loading"
        :data-goal-id="sharedGoalId"
        :filter-by-label="null"
        :show-finished="true"
        :show-archived="false"
        :show-prop-task-height="false"
        :search-string="null"
        :finish-dates="null"
        :session-from="null"
        :session-to="null"
        :tasks-in-session="[]"
        :is-dayplan="false"
        :sessionId="null"
        :show-reduced-dayplan="true"
        @drag-start="onDragStart"
        @drag-end="onDragEnd"
      />
    </div>

    <hr class="my-4">
    -->
    <!--
    <kanban-list
      style="margin: 0 auto;"
      :show-header="false"
      :lane="commitmentById( message.goalId, message.commitmentId ) /* TODO */"
      :goal-id="message.goalId"
      :loading="tasks_loading"
      :show-finished="true"
      :show-archived="true"
      :show-prop-task-height="false"
      :filter-by-label="null"
      :search-string="null"
      :finish-dates="null"
      :session-from="null"
      :session-to="null"
      :tasks-in-session="[{
        cachedTitle: 'cachedTitle',
        cachedFinishedAt: null,
        duration: 15 * 60,
        taskId: message.taskId,
        from: 1234567890,
        sortidx: 1
      }]"
      :is-dayplan="false"
      :session-id="null"
      :show-reduced-dayplan="true"
      @drag-start="onDragStart"
      @drag-end="onDragEnd"
    />
    -->

    <task-list
      v-if="tasklist && goalHasBeenAccepted"
      style="border: none"
      ref="tasklist"
      list-type="unplanned"
      :list-is-editable="true"
      :goal-id="message.goalId"
      :list-id="message.commitmentId"
      :tasklist="tasklist"
      :tasklist-all="tasklist"
      :allow-to-reorder="false"
      :show-prop-task-height="false"
      :assigned-user-id="message.memberId"
      :finish-dates="null"
      :active-task="null"
      :tasks-in-session="[]"
      :width="null"
      :is-dayplan="false"
      :sessionId="null /*sessionId*/"
      :show-reduced-dayplan="false"
      @drag-start="onDragStart"
      @drag-end="onDragEnd"
    />
    <div v-else-if="!goalHasBeenAccepted">
      <el-alert
        class="mb-2 mt-2"
        title="Goal has not been accepted yet.."
        type="warning"
        :closable="false" />
    </div>
    <div v-else>
      <el-alert
        class="mb-2 mt-2"
        title="Task has been deleted."
        type="error"
        :closable="false" />
    </div>

    <!-- <pre class="mini-pre">tasks_loading: {{tasks_loading}}</pre> -->
    <!-- <pre class="mini-pre">message: {{message}}</pre> -->
  </div>
</template>

<script>
// import KanbanList from '@/components/GoalPage/Elements/KanbanList';
import TaskList from '@/components/GoalPage/Elements/TaskList';

export default {
  props: {
    message: {
      required: true
    },
  },
  data: () => ({
    tasks_loading: null,

    // TODO: @achim create new commitment and change sharedCommitmentId
    // sharedGoalId: '-LgYoWmqVpfomXJ6A4tP',
    // sharedCommitmentId: '-LgYpPJpPgrNjyuQAOzH',
  }),
  created() {
    if ( this.tasks_loading === null) {
      this.tasks_loading = true;
      this.$models.task.subscribe_to_goal_tasks( this.message.goalId ).then(() => {
        this.tasks_loading = false;
      });
    }
  },
  computed: {
    /*
    sharedCommitment() {
      return this.$models.commitment
        .with({ goalId: this.sharedGoalId }) // TODO!!! uid
        .subscribeNode(this.sharedCommitmentId);
    }
    */

    tasklist() {
      if (this.tasks_loading) {
        return [];
      }

      // let all_tasklists = this.$models.task.with({ goalId: this.message.goalId }).getters.lane_task_list_all_users;
      // return all_tasklists[this.message.commitmentId] || [];

      // console.log("{ goalId: this.message.goalId, uid: this.message.memberId }", { goalId: this.message.goalId, uid: this.message.memberId })

      let task = this.$models.taskMeta
        .with({ goalId: this.message.goalId, uid: this.message.memberId })
        .getNode( this.message.taskId );

      if ( task ) {
        task.memberId = this.message.memberId // See @/models/task/index.js
        return [ task ];
      }

      return null
    },

    goalHasBeenAccepted() {
      // TODO: Does not check if goal was deleted
      let all_goal_ids = Object.keys( this.$models.goalMeta.getters.all_goals_user );
      return all_goal_ids.includes( this.message.goalId );
    },
  },
  methods: {

    commitmentById( goalId, commitmentId ) {
      return this.$models.commitmentMeta
        .with({ goalId })
        .getNode(commitmentId);
      /* return this.$models.commitment
        .with({ goalId, uid:  })
        .subscribeNode(commitmentId); */
    },

    onDragStart(item) {
      console.log('FlowTasklist onDragStart', item)
      // this.$emit('drag-task-start', item)
    },

    onDragEnd(destination) {
      console.log('FlowTasklist onDragEnd', destination)
      // this.$emit('drag-task-end', destination)
    },

    focus() {
      this.$refs.tasklist.focusOnTask( this.message.taskId );
    }
  },
  components: {
    // KanbanList,
    TaskList,
  }
};
</script>
